import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import { MSelect } from "components/Shared";
import ContentEditable from "react-contenteditable";

export const NOTE_INTERNAL = "NOTE_INTERNAL";
export const NOTE_EXTERNAL = "NOTE_EXTERNAL";
const noteTypeOptions = [
  { label: "Internal", value: NOTE_INTERNAL },
  { label: "External", value: NOTE_EXTERNAL }
];

const NoteInputField = props => {
  const [noteType, setNoteType] = useState(noteTypeOptions[0].value);
  const [noteText, setNoteText] = useState(props.note ?? null);
  const [isFocused, setIsFocused] = useState(false);
  
  
  const textChangeHandler = event => {
    let newText = event.target?.value || event.target?.textContent || "";
    setNoteText(newText);
  };

  const onSaveNote = () => {
    props.showNoteType
      ? props.saveNote(noteText, noteType)
      : props.saveNote(noteText);
    setNoteText(null);
    if (props.showNoteType){
      setNoteType(noteTypeOptions[0].value);
    }
  };

  // Grid sizes for dropdown
  const dropdownSize = props.showAsDialog ? 4 : 2;

  // Hide placeholder when focused or has text
  const showPlaceholder = !noteText && !isFocused;

  return (
    <>
    {noteType.value === NOTE_EXTERNAL && (
      <Box component="span" sx={{ color: 'var(--primary-color)', ml: 1, fontWeight: 'bold' }}>
        Warning: External notes are visible to all users
      </Box>
    )}
      <Grid container spacing={1} sx={{ 
        width: '100%', 
        minWidth: 400,
        alignItems: 'flex-start',
        flexWrap: 'nowrap',
        mb: 2,
        mt: props.showAsDialog ? 2 : 0,
        px: props.showAsDialog ? 2 : 0,
        boxSizing: 'border-box',
        '& .content-editable': { wordBreak: 'break-all', padding: '8px 12px', boxSizing: 'border-box' },
      }}>
        <Grid
          size="grow"
          className={showPlaceholder ? "content-editable-placeholder-enabled" : "content-editable-placeholder-disabled"}
          sx={{ position: "relative" }}
        >
          <p className="case-history-input-placeholder">{props.placeholder}</p>
          <ContentEditable
            id="content-editable"
            className={"content-editable"}
            onChange={e => textChangeHandler(e)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            html={noteText ?? ""}
            style={{
              maxHeight: "300px",
              minHeight: props.showAsDialog ? 130 : 65,
              width: "100%"
            }}
            />
        </Grid>
        {props.showNoteType && <Grid size={dropdownSize}>
          <MSelect
            value={noteTypeOptions.find(opt => opt.value === noteType)}
            onChange={(selected) => setNoteType(selected?.value || noteTypeOptions[0].value)}
            options={noteTypeOptions}
            menuPortalTarget={document.body}
            styles={{
              container: (base) => ({ ...base, minWidth: 100 }),
              singleValue: (base) => ({ ...base, display: 'flex', alignItems: 'center' }),
              valueContainer: (base) => ({ ...base, display: 'flex', alignItems: 'center' }),
              indicatorsContainer: (base) => ({ ...base, alignItems: 'center' }),
            }}
          />
        </Grid>}
        <Grid size="auto">
          <Button
            onClick={onSaveNote}
            disabled={!noteText}
            type="submit"
            className="case-history-input-field-button"
          >
            {props.saveButtonLabel ?? "Save"}
          </Button>
        </Grid>
        {props.onCancel && <Grid size="auto">
          <Button
            onClick={props.onCancel} type="button"
            className="case-history-input-field-button"
          >
            Cancel
          </Button>
        </Grid>}
      </Grid>
    </>
  );
};

NoteInputField.propTypes = {
  note: PropTypes.string, // Note text
  setNote: PropTypes.func,  // Set note text in parent state
  saveNote: PropTypes.func, // Save note, this is called with the noteText. If showNoteType = true, this will be called with the noteType value as the 2nd argument
  placeholder: PropTypes.string,  // Placeholder text to display in empty text box
  showNoteType: PropTypes.bool, // Show choice to choosing internal or external note
  showAsDialog: PropTypes.bool, // When true, styles are updated to better accomodate dialog format
  onCancel: PropTypes.func, // If provided, cancel button is shown (for use as dialog)
  saveButtonLabel: PropTypes.string,  // Optional, overrides "Save" as button label
};

export default NoteInputField;
